module.exports = __webpack_public_path__ + "static/media/student profile.47a81ceb.svg";